import {CheckoutNavigationService, ModalType} from '@wix/wixstores-client-storefront-sdk';
import {getAdditionalFeesPrice, getCatalogAppIds, getNumberOfAdditionalFees} from './bi.utils';
import {CartSummaryModel} from '../models/CartSummary/CartSummary.model';
import {CartModel} from '../models/Cart/Cart.model';

export const openNoOnlinePaymentsModal = async (
  checkoutNavigationService: CheckoutNavigationService,
  isEditorX: boolean,
  cartModel: CartModel,
  cartSummary: CartSummaryModel
): Promise<void> => {
  const destination = cartModel.deliveryInfo?.address;
  const catalogAppId = getCatalogAppIds(cartModel);
  const additionalFeesPrice = getAdditionalFeesPrice(cartSummary);
  const additionalFeesNumber = getNumberOfAdditionalFees(cartSummary);
  await checkoutNavigationService.openLegacyCartModal(
    ModalType.NoOnlinePayments,
    {destination, catalogAppId, additionalFeesPrice, additionalFeesNumber},
    isEditorX
  );
};
